import React from 'react';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import newArticle from 'four-nets/icons/svg/icon_new-article.svg';
import gallery from 'four-nets/icons/svg/icon_gallery.svg';
import story from 'four-nets/icons/svg/icon_story.svg';
import heart from 'four-nets/icons/svg/icon_heart.svg';

import defaultStyles from './post-type-header.scss';
import { PostType, PostCategory } from '../mutations/create-post.graphql.types';

export interface Props {
    styles: typeof defaultStyles;
    postType: PostType;
    postCategory?: PostCategory;
    setTypeAndCategory: (postType: PostType, postCategory?: PostCategory) => void;
}

class PostTypeHeader extends React.PureComponent<Props> {
    typeButtonClassNames = (postType: PostType, postCategory?: PostCategory) => {
        const styles = this.props.styles!;
        const typeButtonClassNames = [styles.typeButton];

        if (postType === this.props.postType && postCategory === this.props.postCategory) {
            typeButtonClassNames.push(styles.active);
        }

        if (postCategory === 'WEDDING_ALBUM') {
            typeButtonClassNames.push(styles.onlyWedding);
        }

        return typeButtonClassNames.join(' ');
    };

    render() {
        const { setTypeAndCategory } = this.props;
        const styles = this.props.styles!;

        return (
            <div className={styles.type}>
                <button
                    onClick={() => setTypeAndCategory('POST_SHORT_MESSAGE')}
                    className={this.typeButtonClassNames('POST_SHORT_MESSAGE')}
                >
                    <SVGIcon style={{ image: styles.postTypeIcon }} src={newArticle} />
                    <FormattedMessage id='SHORT_MESSAGE' />
                </button>
                <button
                    onClick={() => setTypeAndCategory('POST_ALBUM')}
                    className={this.typeButtonClassNames('POST_ALBUM')}
                >
                    <SVGIcon style={{ image: styles.postTypeIcon }} src={gallery} />
                    <FormattedMessage id='ALBUM' />
                </button>
                <button
                    onClick={() => {
                        setTypeAndCategory('POST_ALBUM', 'WEDDING_ALBUM');
                    }}
                    className={this.typeButtonClassNames('POST_ALBUM', 'WEDDING_ALBUM')}
                >
                    <SVGIcon style={{ image: styles.postTypeIcon }} src={heart} />
                    <FormattedMessage id='WEDDING_ALBUM' />
                </button>
                <button
                    onClick={() => setTypeAndCategory('POST_ARTICLE')}
                    className={this.typeButtonClassNames('POST_ARTICLE')}
                >
                    <SVGIcon style={{ image: styles.postTypeIcon }} src={story} />
                    <FormattedMessage id='ARTICLE' />
                </button>
            </div>
        );
    }
}

export default Styled(defaultStyles)(PostTypeHeader);
